import React, { useEffect, useState } from "react";
import AppNavbar from "../../components/common/AppNavbar";
import { fetchNewsByCategory } from "../../services/api";
import Loading from "../../components/common/Loading";
import NewsSection from "../../components/home/NewsSection";
import YouTubeVideoList from "../../components/Entertainment/YouTubeVideoList";

function Entertainment() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const data = await fetchNewsByCategory("entertainment");
      setNews(data);
      setLoading(false);
    }
    load();
  }, []);

  if (loading) return <Loading />;

  return (
    <>
      <AppNavbar />
      <div style={{ padding: "20px" }}>
        <div id="container">
          <NewsSection
            title="Entertainment News"
            articles={news}
            category="entertainment"
          />
        </div>
        <YouTubeVideoList />
      </div>
    </>
  );
}

export default Entertainment;
